import { postUserVisit, setCurrentRoute, setpreviousRoute } from "components/app/App.slice";
import { isEmpty } from "lodash";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getLoggedInUserDetails } from "utils/CommonFunctions";
import { commonApiCallParam, pathToBeIgnorePerUser, removeParamFromSearch } from "utils/UserAnalyticsUtils";

// Module-level guard: same path par dobara run na ho (survives Strict Mode remount)
let lastHandledPath: string | null = null;

const RouteChangeTracker = React.memo(function RouteChangeTracker() {
  const loggedInUserDetails = useAppSelector((state) => state.app.loggedInUserDetails);
  const myPlanDetails: any = useAppSelector((state) => state.myPlanDetails.myPlanDetails);
  const libraryDetails: any = useAppSelector((state) => state.planDetails.planDetails);
  const librarySearch = useAppSelector((state) => state.Library.sharedLinkDetails);
  const currentRoute = useAppSelector((state) => state.app.currentRoute);
  const location = useLocation();

  const dispatch = useAppDispatch();

  // Utility function to check if two URLs are same
  // except some ignored query params (default: "search")
  const isSameExceptParams = (prev: string | null, curr: string, ignoreParams: string[] = ["search", "q"]): boolean => {
    // If there is no previous URL, we cannot compare
    if (!prev) return false;

    // Use a base origin so relative URLs can also be parsed correctly
    const prevUrl = new URL(prev, window.location.origin);
    const currUrl = new URL(curr, window.location.origin);

    // If the pathnames are different, the URLs are not the same
    if (prevUrl.pathname !== currUrl.pathname) return false;

    // Extract query parameters
    const prevParams = new URLSearchParams(prevUrl.search);
    const currParams = new URLSearchParams(currUrl.search);

    // Remove ignored parameters (e.g., "search") before comparison
    ignoreParams.forEach((p) => {
      prevParams.delete(p);
      currParams.delete(p);
    });

    // Compare the remaining query parameters
    return prevParams.toString() === currParams.toString();
  };

  const apiCall = async (page: any) => {
    await dispatch(postUserVisit(page));
  };

  useEffect(() => {
    const currentUrl = window.location.pathname;
    const hasLibrarySearch = location.pathname.includes("library/search");
    const queryParams = new URLSearchParams(location.search);
    const hasUUID = queryParams.has("uuid");
    if (hasLibrarySearch && hasUUID && isEmpty(librarySearch)) return;
    if (
      (currentUrl.startsWith("/myplandetails/") || currentUrl.startsWith("/inncodeplandetails/")) &&
      isEmpty(myPlanDetails)
    )
      return;
    if (currentUrl.startsWith("/plandetails/") && isEmpty(libraryDetails)) return;
    const userDetails = getLoggedInUserDetails();
    if (!isEmpty(loggedInUserDetails) && !isEmpty(userDetails)) {
      if (!pathToBeIgnorePerUser(userDetails)) return;
      const current = location.pathname + removeParamFromSearch(location.search, "code");
      const isCodeExistInQuery = isSameExceptParams(lastHandledPath, current);
      if (isSameExceptParams(lastHandledPath, current) || isCodeExistInQuery) {
        return;
      }

      // If the path hasn’t changed, then skip (prevents initial double + parent re-renders)
      if (current === lastHandledPath || currentRoute === current) return;

      dispatch(setpreviousRoute(lastHandledPath));
      dispatch(setCurrentRoute(current));
      const getParams = commonApiCallParam(false, myPlanDetails);
      apiCall(getParams);
      lastHandledPath = current;
    }
  }, [location, loggedInUserDetails, getLoggedInUserDetails, myPlanDetails, libraryDetails, librarySearch]);

  return null;
});

export default RouteChangeTracker;
